module.exports = __webpack_public_path__ + "assets/icon_early_warning_default.30d096fc.svg";